import styled from 'styled-components'

export const ContainerQuestion = styled.div`
  width: 24px;
  height: 24px;
  position: absolute;
  top: -60px;
  right: 0;
  z-index: 1;
  cursor: pointer;
`
